import { View } from "@novorender/api";
import { ReadonlyQuat, ReadonlyVec3, vec2, vec3 } from "gl-matrix";

function fallbackScreenPos(view: View, anchor: ReadonlyVec3, canvasWidth: number, canvasHeight: number): vec2 {
    const { position, rotation } = view.renderState.camera;
    const right = vec3.transformQuat(vec3.create(), vec3.fromValues(1, 0, 0), rotation as ReadonlyQuat);
    const up = vec3.transformQuat(vec3.create(), vec3.fromValues(0, 1, 0), rotation as ReadonlyQuat);
    const rel = vec3.sub(vec3.create(), anchor, position);
    const dir = vec2.fromValues(vec3.dot(rel, right), -vec3.dot(rel, up));
    if (vec2.length(dir) < 1e-6) {
        vec2.set(dir, 1, 0);
    } else {
        vec2.normalize(dir, dir);
    }
    return vec2.fromValues(canvasWidth / 2 + dir[0] * canvasWidth * 2, canvasHeight / 2 + dir[1] * canvasHeight * 2);
}

export function projectPlaneAnchorToScreen(
    view: View,
    anchor: ReadonlyVec3,
    options?: { canvasWidth?: number; canvasHeight?: number; clampToCanvas?: boolean },
): vec2 | undefined {
    const [projected] = view.convert.worldSpaceToScreenSpace([anchor], { round: false });
    let point =
        projected && Number.isFinite(projected[0]) && Number.isFinite(projected[1]) ? vec2.clone(projected) : undefined;

    const canvasWidth = options?.canvasWidth ?? 0;
    const canvasHeight = options?.canvasHeight ?? 0;
    if (!point && canvasWidth > 0 && canvasHeight > 0) {
        point = fallbackScreenPos(view, anchor, canvasWidth, canvasHeight);
    }

    if (!point) {
        return undefined;
    }

    if (options?.clampToCanvas && canvasWidth > 0 && canvasHeight > 0) {
        point[0] = Math.max(0, Math.min(canvasWidth, point[0]));
        point[1] = Math.max(0, Math.min(canvasHeight, point[1]));
    }

    return point;
}
